// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3084": "27c82843f27a","4788": "b91968ede32f","6603": "4d34ffbfd2e4","8357": "dd422574e14d",}[chunkId] + ".css"
}